<app-group-header [Heading]="'Kondensator'"
				  [chart]="chart"
				  [info]="info"
				  [noChart]="true"
				  (chartEvent)="getChartEvent($event)"
				  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Ladung'"
					  [Error]="charge?.isError"
					  [ErrorLevel]="charge?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[charge?.TimeseriesData]"
					  [Unit]="'%'"
					  [Legend]="['Ladung']"
					  [Info]="'Aktuelle Ladung.'"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Am Laden'"
					  [Error]="charging?.isError"
					  [ErrorLevel]="charging?.status"
					  [showChart]="chart"
					  [showInfo]="info"
                      [customTemplate]="custom"
                      [customNoData]="charging == null"
					  [Legend]="['Am Laden']"
					  [Info]="'Gibt an, ob aktuell geladen wird.'"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

    <ng-template #custom>
        <div *ngIf="charging?.TimeseriesData?.currentDatapoint.value === 0">
            {{'Nein' | translate}}
        </div>
        <div *ngIf="charging?.TimeseriesData?.currentDatapoint.value === 1">
            {{'Ja' | translate}}
        </div>
    </ng-template>

	<app-default-card class="card" style="border: none; border-radius: unset;"
					  [Heading]="'Spannung'"
					  [Error]="voltage?.isError"
					  [ErrorLevel]="voltage?.status"
					  [showChart]="chart"
					  [showInfo]="info"
					  [Values]="[voltage?.TimeseriesData]"
					  [Unit]="'V'"
					  [Legend]="['Spannung']"
					  [Info]="'Aktuelle Spannung.'"
					  [resizeEvent]="childResizeEvent">
	</app-default-card>

</div>
